const runtimeEnv = window.__env__ || {}

const env = {
  baseURL: runtimeEnv.baseURL,
  normalURL: runtimeEnv.normalURL,
  webserviceHost: runtimeEnv.webserviceHost,
  webservicePort: runtimeEnv.webservicePort,
  pusherKey: runtimeEnv.pusherKey,
  painelInatividade: runtimeEnv.painelInatividade,
  mode: runtimeEnv.mode,
}

export default env
